import 'magnific-popup'


function qaAgreeOpen() {
  $.magnificPopup.open({
    items: [
      {
        src: '#qaAgree',
        type: 'inline',

      }
    ],
    mainClass: 'p-whiteBackModal',
    closeOnBgClick: false,
    closeBtnInside: false,
    showCloseBtn: false,
    fixedContentPos: true,
    enableEscapeKey: false,
    callbacks: {
      open: function(){
        const scrollpos = $(window).scrollTop()
        $('body').css('overflow','hidden');
        $('body').css('height','100%');
        $('html').css('height','100%');
        $('.l-container').css({
          position: 'fixed',
          height: '100%',
          overflow: 'hidden',
          width: '100%',
          top: -scrollpos,
        })
        .attr('data-top', scrollpos)
      },
      close: function(){
        $('body').css('overflow','auto');
        $('body').css('height','auto');
        $('html').css('height','auto');
        const returnpos = parseInt($('.l-container').attr('data-top'))
        $('.l-container').removeAttr('style')
        $(window).scrollTop(returnpos)
      }
    }
  }, 0);
}

$(function() {

  $(document).on('click touchend','.js-qaAgreeBtn',  function() {
    if($(this).parent().hasClass('isActive')) {
      return false;
    } else {
      var hrefURL = $(this).attr('href');
      $('.js-qaAgreeLink').attr('href',hrefURL);
      qaAgreeOpen();
      return false;
    }
  });

  $('.js-qaAgreeLink').on('click',function(event){
    event.preventDefault();
    var linkUrl = $(this).attr('href');
    $.magnificPopup.close();
    location.href = linkUrl;
  });

  $(document).on('click touchend','.js-qaAgreeModalClose',  function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});
